module.exports = "https://cdn.schoolblocks.com/assets/_next/static/media/schoology_logo_small-d0e8a.png";